import axios from "axios";
import { Loading } from "element-ui";
import { Message } from "element-ui";
import router from "../router";
import i18n from "@/components/common/i18n";
import qs from 'qs'
import { json } from "body-parser";

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // baseURL: 'http://192.168.0.116:8088/pams/api',
    baseURL: process.env.VUE_APP_SERVER_BASE_URL,
    timeout: 10 * 60 * 1000,
    headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
    },
});

// 创建一个loading实例
let loadingInstance = null;
/**
 * 请求拦截器
 */
service.interceptors.request.use(
    (config) => {
        // 初始化loading实例
        loadingInstance = Loading.service({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        if (config.method === "get") {
            // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
            config.paramsSerializer = function(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            };
        }
        if (typeof config.data == "string" && isNaN(config.data)) {
            config.headers["content-type"] = "text/plain";
        }
        config.headers["x-access-token"] = localStorage.getItem("token");
        return config;
    },
    (error) => {
        console.error(error);
        return Promise.reject();
    }
);

/**
 * 响应拦截器
 */
service.interceptors.response.use(
    (response) => {
        console.log('response', response);

        // loading关闭
        loadingInstance.close();
        if (response.status === 200 || response.status === 201) {
            if (response.headers["x-access-token"]) {
                localStorage.setItem("token", response.headers["x-access-token"]);
            }
            if (response.config.fullResponse) {
                return response;
            }
            if (response.headers["X-Total-Count"]) {
                let obj = {};
                obj.total = response.headers["X-Total-Count"];
                obj.data = response.data;
                return obj;
            }
            return response.data;
        } else {
            Promise.reject(response.data);
        }
    },
    (error) => {
        loadingInstance.close();
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 无token或token过期
                // 登录过期对用户进行提示
                // 清除本地token
                // 跳转登录页面
                case 401:
                    localStorage.clear();
                    Message.warning({
                        message: "会话已超时，请重新登录",
                        duration: 1000,
                    });
                    setTimeout(() => {
                        router.replace({
                            path: "/",
                            query: {
                                redirect: router.currentRoute.fullPath,
                            },
                        });
                    }, 1000);
                    window.location.reload();
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token
                    // 跳转登录页面
                case 403:
                    Message.warning({
                        message: "没有权限完成此操作",
                        duration: 1000,
                    });
                    // localStorage.clear();
                    break;

                    // 404请求不存在
                case 404:
                    Message.warning({
                        message: "网络请求不存在",
                        duration: 1500,
                    });
                    break;
                    // 其他错误，直接抛出错误提示
                case 500:
                    if (error.response.data.detail == "No value present") {
                        Message.warning({
                            message: "未登录或会话已超时，请重新登录",
                            duration: 1000,
                        });
                        setTimeout(() => {
                            router.replace({
                                path: "/",
                                query: {
                                    redirect: router.currentRoute.fullPath,
                                },
                            });
                        }, 1000);
                        window.location.reload();
                    } else {
                        let message = "服务器内部错误";
                        if (error.response.data.msg) {
                            message = error.response.data.msg;
                        }
                        if (error.response.data.toString() == "[object Blob]") {
                            var reader = new FileReader();
                            reader.addEventListener("loadend", function(e) {
                                // 输出字符串 {hello: world}
                                let data = JSON.parse(e.target.result);
                                if (data.msg) {
                                    message = data.msg;
                                }
                                Message.error({
                                    message: message,
                                    duration: 2500,
                                    showClose: true,
                                });
                            });
                            reader.readAsText(error.response.data);
                        } else {
                            console.log("dwadwadawdwa", error.response.data.msg)
                            if (!error.response.data.msg) {
                                Message.error({
                                    message: message,
                                    duration: 2500,
                                    showClose: true,
                                });
                            } else if (error.response.data.msg.split(',').length > 1) {
                                return JSON.stringify(error.response.data)
                            } else {
                                Message.error({
                                    message: message,
                                    duration: 2500,
                                    showClose: true,
                                });
                            }
                        }
                    }
                    break;
                default:
                    Message.error({
                        message: error.response.data.msg,
                        duration: 2500,
                        showClose: true,
                    });
            }
        }
        return Promise.reject(error);
    }
);

export default service;